module.exports = __webpack_public_path__ + "static/household-a041bf9f65d2da07fdcc067a74b83bcd.png";